module.exports = __webpack_public_path__ + "media/images/play-bcb218b99c6e567ca1cf8e4773cabc33.jpg";